<template>
  <div class="app-container">
    <div class="filter-container">
      <div class="filter-item">
        <el-select v-model="listQuery.type" placeholder="收支类型" clearable>
          <el-option label="收入" :value="1" />
          <el-option label="支出" :value="2" />
        </el-select>
      </div>
      <div class="filter-item">
        <el-input v-model="listQuery.user_name" placeholder="请输入用户名" class="filter-item" clearable />
      </div>
      <div style="margin: 0 20px;min-width: 48px;">时间段</div>
      <div class="filter-item">
        <el-date-picker v-model="filteDateRange" type="daterange" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" @change="onChangeDateRange">
        </el-date-picker>
      </div>
      <div class="filter-item">
        <el-select v-model="listQuery.source_type" placeholder="来源类型" clearable>
          <el-option label="积分兑换" :value="1" />
          <el-option label="抽奖" :value="2" />
          <el-option label="体验" :value="3" />
          <el-option label="线下活动" :value="4" />
          <el-option label="签到" :value="5" />
          <el-option label="邀请用户" :value="6" />
        </el-select>
      </div>
      <el-button type="primary" :loading="listLoading" icon="el-icon-search" @click="handleFilter"
        style="margin-right: 100px;">搜索</el-button>
      <el-button type="warning" :loading="listLoading" icon="el-icon-upload2" @click="exportExcel">导出Excel</el-button>
    </div>

    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" size="small" border fit
      highlight-current-row>
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">{{ scope.$index + 1 }}</template>
      </el-table-column>

      <el-table-column prop="user_info.name" label="用户名" min-width="80" align="center" />

      <el-table-column label="用户头像" min-width="80" align="center">
        <template slot-scope="scope" v-if="scope.row.user_info">
          <el-image style="width: 50px; height: 50px" :src="scope.row.user_info.head_img" fit="cover"></el-image>
        </template>
      </el-table-column>

      <el-table-column prop="integral" label="积分明细" min-width="80" align="center" />

      <el-table-column label="收支类型" min-width="80" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.type === 1" type="success">收入</el-tag>
          <el-tag v-else type="danger">支出</el-tag>
        </template>
      </el-table-column>

      <el-table-column prop="details" label="来源类型" min-width="80" align="center" />

      <el-table-column prop="created_at" label="时间" min-width="80" align="center" />
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50, 100]" :page-size="listQuery.limit"
        :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </div>

  </div>
</template>
  
<script>
// 积分管理-交易明细

import { pointCompensation } from "@/api/pointManagement"
import request from "@/utils/request";
import * as XLSX from "xlsx"

export default {
  data() {
    return {
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        start_at: null,
        end_at: null,
        user_name: '',
        type: null,
        source_type: '',
      },
      filteDateRange: null,
      dateList: []
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      this.listLoading = true;

      const { data, code } = await pointCompensation.transactionDetail(this.listQuery)
      if (code === 0) {
        this.list = data.data;
        this.total = data.total;
      }
      this.listLoading = false;
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList();
    },
    onChangeDateRange(t) {
      if (t === null) {
        this.listQuery.start_at = null
        this.listQuery.end_at = null
        return
      }
      this.listQuery.start_at = t[0]
      this.listQuery.end_at = `${t[1].split(' ')[0]} 23:59:59`
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },

    async exportExcel() {
      console.log('exportExcel')
      // +++修改excel-积分管理-交易明细-附件8.2---ok
      const { total } = this
      if (!total) return

      try {
        const { data: { data: reqData } } = await pointCompensation.transactionDetail({ ...this.listQuery, page: 1, limit: 99999999999 })

        var wb = XLSX.utils.book_new();

        var excelData = [
          ['序号', '明细类型', '项目', '积分', '积分余额', '操作时间', '操作管理员', '用户名', '性別', '年龄', '手机号', '居住地-国家', '居住地-省份', '微信ID', '邮箱', '擅长领域'],
          ...reqData.map((item, index) => {
            if (item.user_info) {
              return [
                index + 1,
                item.type === 1 ? '新增' : '扣除',
                item.details,
                item.integral,
                item.surplus_integral,
                item.updated_at,
                item.grant_account_name,
                item.user_info.name,
                item.user_info.gender === 1 ? '男性' : item.user_info.gender === 2 ? '女性' : '未设置',
                item.user_info.age_group === 1 ? '20岁以下' : item.user_info.age_group === 2 ? '21~30岁' : item.user_info.age_group === 3 ? '31~40岁' : item.user_info.age_group === 4 ? '41~50岁' : item.user_info.age_group === 5 ? '51岁以上' : '未设置',
                item.user_info.account,
                item.user_info.country,
                item.user_info.provinces,
                item.user_info.wx_id,
                item.user_info.email,
                item.user_info.evaluation_type_field.length > 0 ? item.user_info.evaluation_type_field.map(item => item.name).join(',') : '',
              ]
            }
          })
        ];
        var ws = XLSX.utils.aoa_to_sheet(excelData);
        XLSX.utils.book_append_sheet(wb, ws, "交易明细");
        XLSX.writeFile(wb, "积分管理-交易明细-交易详情.xlsx");

        this.$notify.info({
          title: '消息',
          message: '请等待, 正在生成Excel表格文件...'
        });
      } catch (e) {
        console.log(e)
        this.$notify.error({
          title: '错误',
          message: '获取数据错误!'
        });
      }
    }
  },
  components: {
  },
  watch: {
    dateList: {
      handler(nval) {
        if (nval) {
          this.listQuery.start_at = nval[0]
          this.listQuery.end_at = `${nval[1]} 23:59`
        } else {
          this.listQuery.start_at = this.listQuery.end_at = ''
        }
      },
      deep: true
    }
  }
};
</script>
  
<style rel="stylesheet/scss" lang="scss" scoped>
.filter-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;

  .filter-item {
    text-align: center;

    .filter-name {
      font-size: 13px;
      margin-right: 6.5px;
      color: #606266;
    }
  }
}
</style>
  